import { Component } from '@angular/core';

@Component({
  selector: 'app-arrow-right-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './arrow-right-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class ArrowRightIconComponent {}
